module.exports = __webpack_public_path__ + "media/images/features/5/history-2-2-1469bdf4e3f45527346bb83bed414179.jpg";